module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryInterior1.e7283192.jpg";